import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useQuery } from "react-query";

import {
	customMultiSelectStyles,
	ErrorMessage,
	IndicatorsContainer,
	MultiValueRemove,
	RequiredMark,
	Select,
} from "components";
import { sortedRendReasonsValues } from "mappers";
import { dropdownValuesService } from "services";
import { required } from "validators";

type ReasonSelectProps = {
	loading: boolean;
	control: any;
	errors: any;
	setValue: Function;
	initialValue?: { [key: string]: any }[] | null;
};

const ReasonSelect = ({
	loading = false,
	control,
	errors,
	setValue,
	initialValue,
}: ReasonSelectProps) => {
	const [pendReasonValue, setPendReasonValue] = useState<{
		[key: string]: any;
	}>([]);

	useEffect(() => {
		if (initialValue) {
			setPendReasonValue?.(sortedRendReasonsValues(initialValue));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const { data: pendReasons, isLoading } = useQuery(
		"pendReasons",
		dropdownValuesService.getPendReasons,
	);

	const handleChange = options => {
		const sortToAlphabeticalOptions = sortedRendReasonsValues(options);

		setPendReasonValue(sortToAlphabeticalOptions);
		setValue("reasons", sortToAlphabeticalOptions, {
			shouldDirty: true,
		});
	};

	return (
		<>
			<Form.Label>
				Pend Reason
				<RequiredMark />
			</Form.Label>
			<Controller
				control={control}
				render={({ field }) => (
					<Select
						{...field}
						options={pendReasons}
						value={pendReasonValue}
						isMulti
						getOptionLabel={option => option.name}
						getOptionValue={option => option.id}
						onChange={handleChange}
						loading={loading || isLoading}
						isClearable={false}
						components={{
							IndicatorsContainer,
							MultiValueRemove,
						}}
						placeholder=""
						styles={customMultiSelectStyles}
						className="customMultiSelect"
					/>
				)}
				name="reasons"
				rules={{
					validate: {
						required,
					},
				}}
			/>
			<ErrorMessage field="reasons" errors={errors} />
		</>
	);
};

export default ReasonSelect;
